import EstadosTab from './EstadosTab'
import './EstadosTab.css'

export default EstadosTab